import { render, staticRenderFns } from "./AccountOverviewDetails.vue?vue&type=template&id=dd194ed6&scoped=true&"
import script from "./AccountOverviewDetails.vue?vue&type=script&lang=js&"
export * from "./AccountOverviewDetails.vue?vue&type=script&lang=js&"
import style0 from "./AccountOverviewDetails.vue?vue&type=style&index=0&id=dd194ed6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd194ed6",
  null
  
)

export default component.exports